export const GetCurrentTime = () => {
  const currentDate = new Date();

  const oneWeekAgo = new Date(currentDate);
  oneWeekAgo.setDate(currentDate.getDate() - 7);

  return [oneWeekAgo, currentDate];
};

export const GetLast24Hours = () => {
  const currentDate = new Date();

  const twentyFourHoursAgo = new Date(currentDate);
  twentyFourHoursAgo.setHours(currentDate.getHours() - 24);

  return [twentyFourHoursAgo, currentDate];
};
